import React from 'react';
export function Summary({
  cart,
  pricingData,
  priceType,
  total,
  onClearCart
}) {
  return <div className="mb-8 border-t border-b py-6" data-id="element-212">
      <div className="flex justify-between items-center mb-4" data-id="element-213">
        <h2 className="text-2xl font-bold text-blue-900" data-id="element-214">Quote Summary</h2>
        <button className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700" onClick={onClearCart} data-id="element-215">
          START OVER
        </button>
      </div>
      <div className="overflow-x-auto" data-id="element-216">
        <table className="min-w-full bg-white border" data-id="element-217">
          <thead data-id="element-218">
            <tr className="bg-gray-100" data-id="element-219">
              <th className="py-2 px-4 border text-left" data-id="element-220">Item</th>
              <th className="py-2 px-4 border text-right" data-id="element-221">Price</th>
              <th className="py-2 px-4 border text-center" data-id="element-222">Quantity</th>
              <th className="py-2 px-4 border text-right" data-id="element-223">Subtotal</th>
            </tr>
          </thead>
          <tbody data-id="element-224">
            {Object.entries(cart).map(([itemId, quantity]) => {
            const item = pricingData.find(p => p.id === itemId);
            if (!item) return null;
            const price = item[priceType];
            const subtotal = price * quantity;
            return <tr key={itemId} data-id="element-225">
                  <td className="py-2 px-4 border" data-id="element-226">
                    <div className="font-medium" data-id="element-227">{item.name}</div>
                    {item.description && <div className="text-sm text-gray-600" data-id="element-228">
                        {item.description}
                      </div>}
                  </td>
                  <td className="py-2 px-4 border text-right" data-id="element-229">
                    ${price.toFixed(2)}
                  </td>
                  <td className="py-2 px-4 border text-center" data-id="element-230">{quantity}</td>
                  <td className="py-2 px-4 border text-right" data-id="element-231">
                    ${subtotal.toFixed(2)}
                  </td>
                </tr>;
          })}
          </tbody>
          <tfoot data-id="element-232">
            <tr className="bg-gray-100" data-id="element-233">
              <td colSpan={3} className="py-2 px-4 border text-right font-bold" data-id="element-234">
                Total:
              </td>
              <td className="py-2 px-4 border text-right font-bold" data-id="element-235">
                ${total}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>;
}